function getRoutePath(route) {
  if (typeof route === 'string') {
    return route;
  }
  return route.path;
}
export function getBasenameFromRouting(routing) {
  var _routing$routes;
  if (!(routing !== null && routing !== void 0 && (_routing$routes = routing.routes) !== null && _routing$routes !== void 0 && _routing$routes.length)) {
    return undefined;
  }
  if (routing.routes.length === 1) {
    return getRoutePath(routing.routes[0]);
  }

  // if there is one route which is a substring of all other routes, return that route
  const routePaths = routing.routes.map(getRoutePath);
  let shortestRoute = routePaths[0];
  for (const path of routePaths) {
    if (path.length < shortestRoute.length) {
      shortestRoute = path;
    }
  }
  const shortedRouteEndingInSlash = shortestRoute.endsWith('/') ? shortestRoute : `${shortestRoute}/`;
  if (routePaths.every(path => path === shortestRoute || path.startsWith(shortedRouteEndingInSlash))) {
    return shortestRoute;
  }

  // otherwise, return all the paths and use an array of basenames
  return routePaths;
}